/* eslint-disable */
export default {
  copyToClipboard: 'Kopioi leikepöydälle',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
